<template>
    <div>

        <TextBanner>
       <p> Die ISS braucht etwa 90 Minuten, um einmal um die Erde zu fliegen. <b>Fünf bis acht Mal</b> pro Tag kann man sie bei klarem Nachthimmel mit dem bloßen Auge sehen.</p>
        </TextBanner>

        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_020_p.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_020_l.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>

        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                position: [-1.40,1.34,100],   //[1.56,0.1,30],   //-.9,1.3,200   /-1.57,0.1,100 von obne   -.75,1.32,100
                target: [.5,-15,0]        //[.5,0,0]                           /.5,-30,-8 von oben
            },
            

            iss: {


                Umlaufbahn: {   
                    visible: true,
                    renderingGroupId: 0
                },

                Label_BG_28k:{
                    visible: true,
                    billboardMode: 7,
                    renderingGroupId: 0,
                    Typo_28k: {
                        visible: true,
                        renderingGroupId: 0
                    },
                },

                erde_pivot: {
                    erde: {
                        fade: true,
                        visible: true
                    },
                },

                sonne: {
                    visible: false,
                    fade: true,
                },
                    
            },
           
        },
        babylonReady: function () {

        this.$babylonController.goToAnimation("spacex_anim", 0);


        this.$babylonController.timer.add(2800, () => {
            this.$babylonController.setCameraRadiusLimit(80,200);  //58,200
        });
  
        //this.$audioController.initTrack('speaker', require('./../assets/audio/2496003_Starhorizon_192.mp3'), true, false);

        this.$babylonController.startAnimation("Umlaufbahn_anim", true, 1);

        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
